/* eslint-disable no-unused-vars */
export enum RoutePath {
  ALL = '/*',
  LOGIN = '/',
  NOT_FOUND = '/not-found',
  USER = '/user',
  TILE = '/tile',
  SETTINGS = '/settings',
  MEDIA = '/texture',
  COLOR = '/color'
}
